/**
 * Reactのループ用配列を作成する
 * @param count
 * @returns
 */
export const reactLoop = (count: number) => {
  const indexes = []
  for (let i = 0; i < count; i++) {
    indexes.push(i)
  }
  return indexes
}

/**
 * 自動スクロール
 * @param anchorName
 */
export const scrollToAnchor = (anchorName: string | undefined | null) => {
  if (anchorName) {
    const element = document.getElementById(anchorName)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
    }
  }
}

/**
 * Base64エンコード
 * @param file
 * @returns
 */
export const toBase64 = (file: File) => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve((reader.result as string).replace(/^data:.+;base64,/, ''))
    reader.onerror = (error) => reject(error)
  })
}
